import { render, staticRenderFns } from "./bacth_add.vue?vue&type=template&id=9545ef04&scoped=true"
import script from "./bacth_add.vue?vue&type=script&lang=js"
export * from "./bacth_add.vue?vue&type=script&lang=js"
import style0 from "./bacth_add.vue?vue&type=style&index=0&id=9545ef04&prod&rel=stylesheet%2Fscss&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9545ef04",
  null
  
)

export default component.exports